import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocIncidentsRoute: InvariantJiraRoute = {
	name: 'eoc-incidents',
	path: '/jira/ops/incidents',
	exact: true,
};
